const axios = require('axios');

export async function fetch( method="GET", URL, data={}  ) {
  return axios.get(URL, {
    params: data
  });
}
